/**
 * Map of mutation scope ids used by the react-query hooks. Mutations that
 * share a scope run one at a time.
 */
export const mutationScopes = {
    playlistItemDelete: 'playlistItemDelete',
};
